import { render } from "./QwLink.vue?vue&type=template&id=e90992f4"
import script from "./QwLink.vue?vue&type=script&lang=js"
export * from "./QwLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__